import React from 'react';
import { Text } from '@wix/design-system';
export const SaleBannerContent = ({ saleText, }) => {
    return (React.createElement(Text, { weight: "bold", size: "small" }, saleText));
};
//# sourceMappingURL=SaleBannerContent.js.map